export const SENTRY_DSN = 'https://1040ac6412594052b740502abade5be9@glitch.savandbros.com/5';
